
const authHeaderJson = () => {
  return { 
    'Content-Type': 'application/json', 'handlerichtextsg3': 'handlerichtextsg3'
  };
}

const authHeaderBlob = (type) => {
  return { 
    "x-ms-blob-type": "BlockBlob",
    "Content-Type": type
  };
}

const authHeaderJsonIntegrationFG = () => {
  return { 
    'Content-Type': 'application/json', 'handleintegrationfg': 'handleintegrationfg' 
  };
}

const authHeaderTextPlain = () => {
  return { 
    'accept': 'text/plain', 'handlerichtextsg3': 'handlerichtextsg3'
  };
}

const authHeaderFile = () => {
  return { 
    'Content-Type': 'multipart/form-data', 'handlerichtextsg3': 'handlerichtextsg3'
  };
}

const authHeaderTextPlainJsonPatch = () => {
  return {
    'accept': 'text/plain',  'Content-Type': 'application/json-patch+json', 'handlerichtextsg3': 'handlerichtextsg3'
  };
}


export { authHeaderJson, authHeaderBlob, authHeaderFile, authHeaderTextPlain, authHeaderTextPlainJsonPatch, authHeaderJsonIntegrationFG }